import Icon from '@/components/atoms/Icon';
import { classnames } from '@/libs/utils';

const EventMigrationInProgress = ({ showLoaderOnPage }: { showLoaderOnPage: boolean }) => {
  return (
    <div
      className={classnames(
        'flex size-full flex-col items-center justify-center bg-[#EAECF2]',
        showLoaderOnPage ? 'fixed inset-0' : ''
      )}
    >
      <Icon name="IconHourglassHigh" color="#657389" size={24} />
      <div className="mt-4 flex flex-col items-center justify-center text-sm font-medium text-[#657389]">
        <div>Video is offline during migration.</div>
        <div>Please check back soon.</div>
      </div>
    </div>
  );
};

export default EventMigrationInProgress;
